import { HeadingGroup, NavGroup } from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import ShopCertificateList from "../ShopCertificateList";
import KalyanCertificateTable from "./KalyanCertificateTable";

const ImageCertificationList = () => {
  const location = useLocation();
  const activeTab =
    new URLSearchParams(location.search).get("activeTab") || "old";

  const tabNavs = [
    {
      label: "New Certificate",
      title: "New Certificate",
      link: `/shop-certificate?activeTab=old`,
      active: activeTab === "old",
    },
    {
      label: "Old Certificate",
      title: "Old Certificate",
      link: `/shop-certificate?activeTab=shop`,
      active: activeTab === "shop",
    },
  ];

  return (
    <div>
      <HeadingGroup title={"Shop Certificate"} className={`pro-mb-4`} />
      <div className={`pro-mb-4`}>
        <NavGroup navigations={tabNavs} type={"type-2"} Link={Link} />
      </div>
      {activeTab === "shop" ? <ShopCertificateList /> : <KalyanCertificateTable />}
    </div>
  );
};

export default ImageCertificationList;
